<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      @keydown.esc="dialog = false"
      eager
    >
      <v-card>
        <v-toolbar dark dense color="primary">
          <v-toolbar-title class="ml-2">{{ modalTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialog = false" dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <ReportViewer ref="report" :load="false" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReportViewer from '@/components/report/ReportViewer';

export default {
    components: {
        ReportViewer,
    },
    data() {
        return {
            modalTitle: '',
            dialog: false,
        };
    },
    methods: {
        show(title, params) {
            this.modalTitle = title;
            this.$refs.report.loadReport(JSON.stringify(params || {}));
            this.dialog = true;
        },
    },
};
</script>